module.exports = __webpack_public_path__ + "media/BEFIRST_purimotto.ee5fe27e.mp4";